import PropTypes from "prop-types";
import React, {
	Component
} from "react";
import {
	StyleSheet,
	View,
} from "react-native";
import xtend from "xtend";
import memoize from "memoizee";
import par from "par";

import Style from "ae-style";

import InputLabel from "./Layout/InputLabel";
import InputContainer from "./Layout/InputContainer";
import ErrorMessage from "./Layout/ErrorMessage";
import StyledButton from "ae-base/Base/StyledButton";

import { useResources, useIdPrefix } from "@aetonix/hooks";

const DAY_LIST = [
	"all",
	"mon",
	"tue",
	"wed",
	"thu",
	"fri",
	"sat",
	"sun",
];

const DEFAULT_DAYS = DAY_LIST.reduce(par(setDay, true), {});

const styles = StyleSheet.create({
	first: {
		marginRight: Style.layout.marginSmall,
		marginVertical: Style.layout.marginSmall
	},
	item: {
		marginHorizontal: Style.layout.marginSmall,
		marginVertical: Style.layout.marginSmall
	},
	items: {
		flexDirection: "row",
		flexWrap: "wrap",
		justifyContent: "space-around",
	},
	last: {
		marginLeft: Style.layout.marginSmall,
		marginVertical: Style.layout.marginSmall
	}
});

class DaysComp extends Component {
	constructor(props){
		super(props);

		this.state = {
			hasChanged: false,
			days: DEFAULT_DAYS
		};

		this.update = memoize(updateDay.bind(this));
	}

	render(){
		const localize = this.props.localize;
		const localizeFrom = this.props.localizeFrom;

		const props = this.props;
		const state = this.state;
		const schema = props.schema;
		const defaultValue = props.defaultValue;
		const value_description = schema.value_description;
		const value_localization = schema.value_localization;

		const hasChanged = this.state.hasChanged;
		const renderValue = hasChanged ? state.days : (defaultValue || state.days);

		const update = this.update;

		const renderedDays = DAY_LIST.map(function(day, index, list){
			const first = index === 0;
			const last = index === (list.length - 1);
			const isActive = renderValue === "days" ? false : renderValue[day];

			let dayText = day;
			if(value_localization)
				dayText = localizeFrom(value_localization, day) || day;
			else if(value_description)
				dayText = localize(value_description + "." + day) || day;

			return (
				<DayButton key={day}
					id={props.id + "_" + day}
					day={dayText}
					active={isActive}
					first={first}
					last={last}
					onPress={update(day)} />
			);
		});

		return (
			<InputContainer inline={props.inline}>
				<InputLabel schema={schema} />
				<ErrorMessage id={this.props.id_prefix + props.id + "_error"} errors={props.errors} schema={schema} />
				<View style={styles.items}>
					{renderedDays}
				</View>
			</InputContainer>
		);
	}
}

function updateDay(day) {
	const component = this;
	return function(){
		const state = component.state;
		const props = component.props;

		const hasChanged = state.hasChanged;
		let currentValue;
		if(hasChanged)
			currentValue = state.days;
		else currentValue = props.defaultValue || state.days;

		const newState = !currentValue[day];

		let newValue;
		if(day === "all"){
			newValue = DAY_LIST.reduce(par(setDay, newState), {});
		} else {
			const update = {
				all: false
			};
			update[day] = newState;
			newValue = xtend(currentValue, update);
		}

		component.setState({
			hasChanged: true,
			days: newValue
		});

		const onChange = props.onChange;
		if(onChange) onChange(newValue);
	};
}

function setDay(state, days, day) {
	days[day] = state;
	return days;
}

function DayButton(props){
	const day = props.day;
	const active = props.active;
	const onPress = props.onPress;

	const first = props.first;
	const last = props.last;
	let style = styles.item;

	if(first && !last)
		style = styles.first;
	if(last && !first)
		style = styles.last;

	return (
		<View style={style}>
			<StyledButton id={props.id} fullwidth contrast={active} title={day} onPress={onPress} />
		</View>
	);
}

export default function Days(props){
	const { localize, localizeFrom } = useResources();
	const idPrefix = useIdPrefix();
	return (
		<DaysComp {...props} localize={localize} localizeFrom={localizeFrom} id_prefix={idPrefix} />
	);
}